import { render, staticRenderFns } from "./leave_note.vue?vue&type=template&id=1e50bc18&scoped=true&"
import script from "./leave_note.vue?vue&type=script&lang=js&"
export * from "./leave_note.vue?vue&type=script&lang=js&"
import style0 from "./leave_note.vue?vue&type=style&index=0&id=1e50bc18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50bc18",
  null
  
)

export default component.exports